export default "__VITE_ASSET__c69ef24d__"